( function () {
	'use strict';

	function calendarControl ( moment ) {
		function changeCalendarView ( view ) {
			this.calendarView = view;
		}

		function monthTitle () {
			return moment( this.currentDay ).format( 'MMMM YYYY' );
		}

		return {
			'changeCalendarView' : changeCalendarView,
			'calendarView'       : 'month',
			'calendarTitle'      : 'Schedules',
			'currentDay'         : new Date(),
			'monthTitle'         : monthTitle
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'calendarControl', calendarControl );

	calendarControl.$inject = [ 'moment' ];
} )( );
